import { numberFormat } from '../intl';

export const toQuantityString = (lng: string | undefined, quantity: number) => {
    const quantityString = numberFormat(lng, { minimumFractionDigits: 0 }).format(quantity);
    return `${quantityString}`;
};
